import { BaseFeeTiming, InvoiceStatus } from "@api/shared-runtime/enums";
import type { RouterOutputs } from "@/trpc";

export type CustomerInvoiceList = RouterOutputs["organization"]["listInvoices"];
export type CustomerInvoice = CustomerInvoiceList["invoices"][number];

export const CUSTOMER_INVOICE_STATUS_LABELS: Record<InvoiceStatus, string> = {
  [InvoiceStatus.Draft]: "Draft",
  [InvoiceStatus.Open]: "Due",
  [InvoiceStatus.Paid]: "Paid",
  [InvoiceStatus.Void]: "Void",
  [InvoiceStatus.Uncollectible]: "Uncollectible",
};

export const PAYMENT_FAILED_NOTICE =
  "The last payment attempt on your saved payment method failed. Saile will retry or reach out about payment. You can update the saved payment method above.";

export const PAYMENT_PENDING_LABEL = "Processing";
export const PAYMENT_PENDING_NOTICE =
  "Bank transfers take a few business days to clear.";

export const PAY_NOW_LABEL = "Pay now";
export const RETRY_PAYMENT_LABEL = "Retry payment";
export const ADD_PAYMENT_METHOD_TO_PAY =
  "Add a payment method above to pay this invoice.";
export const PAYMENT_NEEDS_VERIFICATION_NOTICE =
  "Your bank asked to verify this payment, which cannot be done from here. Saile will reach out with another way to pay.";

export const PAY_INVOICE_LABEL = "Pay invoice";
export const PAY_INVOICE_DESCRIPTION =
  "Pay by card or bank transfer on Stripe's secure page.";

export const BILLING_CADENCE_DESCRIPTIONS: Record<BaseFeeTiming, string> = {
  [BaseFeeTiming.InAdvance]:
    "Your base fee is invoiced at the start of each month. Any extra usage from the previous month is included on the same invoice.",
  [BaseFeeTiming.InArrears]:
    "Each month's invoice is issued after the month ends and covers the base fee and any extra usage.",
};
